import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { Box } from '@hub-la/design-system';

const ProgressBar = ({
  viewed,
  progress: _progress = 0,
  maxProgress: _maxProgress = 0
}) => {
  const calcPorcentageProgress = (progress, total) => {
    if (total === 0 || progress === 0) return 0;
    return progress / total * 100;
  };
  const calcWidthBar = () => {
    var _a;
    if (_progress === 0) {
      return viewed ? 100 : 0;
    }
    if (!_progress || !_maxProgress) return 0;
    if (_progress === 0 || _maxProgress === 0) return 0;
    if (_progress > _maxProgress) return 100;
    return (_a = calcPorcentageProgress(_progress, _maxProgress)) !== null && _a !== void 0 ? _a : 0;
  };
  const progressBar = calcWidthBar();
  return jsx(Box, Object.assign({
    position: "absolute",
    height: "3px",
    left: 0,
    right: 0,
    bottom: 1,
    paddingX: 0.25
  }, {
    children: jsx(Box, Object.assign({
      "data-testid": "publication-progress-content",
      position: "relative",
      bgcolor: '#111111',
      height: "3px",
      borderRadius: "20px"
    }, {
      children: progressBar !== 0 && jsx(Box, Object.assign({
        "data-testid": "publication-progress-bar",
        position: "absolute",
        height: "3px",
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: '#CA0000',
        width: `${progressBar}%`,
        borderRadius: "20px"
      }, {
        children: jsx("div", {})
      }))
    }))
  }));
};

export { ProgressBar };
